<div class="custom-filter-container" [class.custom-filter-is-mobile]="isMobile">
    <mat-sidenav-container class="custom-filter-sidenav-container"
        [class.expanded]="isSidenavExpanded()">
        <mat-sidenav #sidenavFilter opened
            [disableClose]="true" 
            [mode]="isSidenavExpanded() ? sidenavMode() : 'side'"
            [fixedTopGap]="56"
            [class.expanded]="isSidenavExpanded()"
            [class.tw-hidden]="!isSidebarVisible"
            [style.width.px]="isSidebarVisible ? sidebarWidth() : 0">

            <div class="sidenav-collapsed" [class.tw-hidden]="isSidenavExpanded()">
                <button mat-icon-button 
                        class="filter-badge-button"
                        aria-label="Open filters sidenav"
                        matBadge="!" 
                        matBadgeSize="small" 
                        matBadgePosition="above after"
                        [matBadgeHidden]="!filterApplied()"
                        matBadgeColor="primary"
                        (click)="toggleSidenav()">
                    <mat-icon>filter_list</mat-icon>
                </button>
            </div>
            <div class="sidenav-expanded" [class.tw-hidden]="!isSidenavExpanded()">
                <div class="tw-flex tw-flex-row" style="height: 100%;">
                    <div class="tw-w-full">
                        @if(isSidebarReady()) { 
                            @if(activeTabs.size > 1) {
                                <mat-tab-group color="primary" animationDuration="0ms" style="height: 100%;" (selectedTabChange)="tabPanelChange($event)"
                                [selectedIndex]="selectedTabIndex">
                                    @if(getFilters('quickFilters').length) {
                                        <mat-tab label="{{'EXTENDED_TABLE.TITLE.QUICK_FILTER' | translate}}">
                                            <ng-container [ngTemplateOutlet]="quickFiltersTemplate"></ng-container>
                                        </mat-tab>
                                    }
                                    @if(getFilters('customFilters').length) {
                                        <mat-tab label="{{'EXTENDED_TABLE.TITLE.CUSTOM_FILTER' | translate}}">
                                            <ng-container [ngTemplateOutlet]="customFiltersTemplate"></ng-container>
                                        </mat-tab>
                                    }
                                </mat-tab-group>
                            } @else {
                                @if(getFilters('quickFilters').length) {
                                    <ng-container [ngTemplateOutlet]="quickFiltersTemplate"></ng-container>
                                }
                                @if(getFilters('customFilters').length) {
                                    <ng-container [ngTemplateOutlet]="customFiltersTemplate"></ng-container>
                                }
                            }
                        }
                    </div>
                </div>
            </div>
        </mat-sidenav>

        
        <mat-sidenav-content [style.margin-left.px]="isSidebarVisible ? (isCompactMode() ? 60 : sidebarWidth()) : 0">
            @if (!isCompactMode()) {
                <div class="resize-handle" appResizable
                    (resizing)="onResize($event)"></div>
            }
            <ng-content select="[Table]"></ng-content>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>


<ng-template #quickFiltersTemplate>
    <app-quick-filters
        [hideResetFilterIcon]="hideResetFilterIcon"
        [quickFilters]="getFilters('quickFilters')"
        [filterStatusSaved]="initialQuickFilters" 
        [triggerOperation]="quickFiltersOperation()"
        [filterApplied]="filterApplied()"
        (outputOperation)="handleQuickFiltersOperation($event)"
    ></app-quick-filters>
</ng-template>

<ng-template #customFiltersTemplate>
    <app-custom-filters
        [hideResetFilterIcon]="hideResetFilterIcon"
        [customFilters]="getFilters('customFilters')"
        [filterStatusSaved]="initialCustomFilters"
        [triggerOperation]="customFiltersOperation()"
        [filterApplied]="filterApplied()"
        (outputOperation)="handleCustomFiltersOperation($event)"
    ></app-custom-filters>
</ng-template>
